import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { VFC } from 'react';

import { DEFAULT_PROFILE_IMAGE_PATH } from '@/constants/images';
import CertifiedBadge from '@/icons/certified-badge.svg';
import { convertImgixURL } from '@/utils/imgixUtils';

import LatestNFTs from './LatestNFTs';
import styles from './MarketplaceCreatorCard.module.scss';

type Props = {
  link: string;
  creatorName: string;
  creatorProfileImageUrl: string;
  userID: string;
  creations: any;
  isCreator: boolean;
};

const MarketplaceCreatorCard: VFC<Props> = ({
  link,
  creatorName,
  creatorProfileImageUrl,
  userID,
  creations,
  isCreator,
}) => {
  const { t } = useTranslation();
  const latestTextPath = isCreator
    ? 'MarketplaceProfiles.LatestTextCreator'
    : 'MarketplaceProfiles.LatestTextCollector';
  const buttonText = isCreator
    ? 'MarketplaceProfiles.ViewButtonCreator'
    : 'MarketplaceProfiles.ViewButtonCollector';
  return (
    <Link href={link}>
      <a className={styles.item} target="_blank" rel="noreferrer">
        <div className={styles.itemBody}>
          <div className={styles.itemImageContainer}>
            {/* Empty div for square space */}
            <div className={styles.itemImageArea} />
            {/* Spread the content all over the div */}
            <div className={styles.itemImageContent}>
              <img
                src={
                  creatorProfileImageUrl
                    ? convertImgixURL(creatorProfileImageUrl, {
                        w: 660,
                        auto: 'compress',
                      })
                    : convertImgixURL(DEFAULT_PROFILE_IMAGE_PATH, {
                        w: 660,
                        auto: 'compress',
                      })
                }
                className={styles.profilePicture}
              ></img>
            </div>
          </div>

          <div className={styles.itemDescription}>
            <div className={styles.itemCreator}>
              <span
                className={creatorName ? styles.creatorName : styles.userIDName}
              >
                {creatorName ? creatorName : userID}
              </span>
              {isCreator && <CertifiedBadge className={styles.badge} />}
            </div>
            <p className={styles.userID}>{userID}</p>
            <h4
              className={
                isCreator
                  ? styles.latestCreatorText
                  : styles.latestCollectorText
              }
            >
              {t(latestTextPath)}
            </h4>
            {creations && (
              <LatestNFTs creations={creations} isCreator={isCreator} />
            )}
            {!creations && <LatestNFTs creations={[]} isCreator={isCreator} />}
          </div>
          <div className={styles.navButton}>
            <button
              className={
                isCreator
                  ? styles.linkButtonCreator
                  : styles.linkButtonCollector
              }
            >
              {' '}
              {t(buttonText)}
            </button>
          </div>
        </div>
      </a>
    </Link>
  );
};

export default MarketplaceCreatorCard;
